import * as VeeValidate from "vee-validate";

VeeValidate.extend("money", {
  getMessage: (field) => "The " + field + " is not a currency value.",
  validate: (value) => {
    var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
    return regex.test(value);
  },
});

VeeValidate.extend("moneyZeroOk", {
  getMessage: (field) => "The " + field + " is not a currency value.",
  validate: (value) => {
    var regex = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
    return regex.test(value);
  },
});

VeeValidate.extend("phoneNumber", {
  getMessage: (field) => "The " + field + " is not a valid phone number.",
  validate: (value) => {
    var regex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    return regex.test(value);
  },
});

VeeValidate.extend("email", {
  getMessage: (field) =>
    "The " +
    field +
    " is not a valid e-mail address.  For multiple e-mail addresses seperate by comma.",
  validate: (value) => {
    var regex = /^(\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{0,20}\s*?,?\s*?)+$/;

    return regex.test(value);
  },
});

VeeValidate.extend("greaterThanZero", {
  getMessage: (field) => field + " needs to be greater than zero.",
  validate: (value) => {
    // value must be > zero
    if (value > 0) return true;
    return false;
  },
});
